import { render, staticRenderFns } from "./TooltipPills.vue?vue&type=template&id=dc3e998a&"
import script from "./TooltipPills.vue?vue&type=script&lang=ts&"
export * from "./TooltipPills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports